import React, { useRef } from 'react';
import CustomInput from '../../CustomInput';
import LogosUploader from '../../LogosUploader/LogosUploader';
import { countryCodesMap } from '../../../shared/data/countryCodesMap';

export default function CompanyDataInputs({
    flag,
    onChange,
    data,
    onFileSelect,
    onDeleteLogo,
    logoErrors,
    logos,
    onChangeCompanyInfo,
    onLogosSizesChange,
    dataStore,
}) {
    const uploadBigLogoButtonRefSV = useRef(null);
    const uploadBigLogoButtonRefNO = useRef(null);
    const uploadBigLogoButtonRefFI = useRef(null);
    const uploadBigLogoButtonRefDA = useRef(null);
    const uploadBigLogoButtonRefIS = useRef(null);
    const uploadSmallLogoButtonRefSV = useRef(null);
    const uploadSmallLogoButtonRefNO = useRef(null);
    const uploadSmallLogoButtonRefFI = useRef(null);
    const uploadSmallLogoButtonRefDA = useRef(null);
    const uploadSmallLogoButtonRefIS = useRef(null);
    const uploadFaviconButtonRefSV = useRef(null);
    const uploadFaviconButtonRefNO = useRef(null);
    const uploadFaviconButtonRefFI = useRef(null);
    const uploadFaviconButtonRefDA = useRef(null);
    const uploadFaviconButtonRefIS = useRef(null);
    const uploadEmailLogoButtonRefSV = useRef(null);
    const uploadEmailLogoButtonRefNO = useRef(null);
    const uploadEmailLogoButtonRefFI = useRef(null);
    const uploadEmailLogoButtonRefDA = useRef(null);
    const uploadEmailLogoButtonRefIS = useRef(null);

    const refsMap = {
        sv: {
            bigLogoButtonRef: uploadBigLogoButtonRefSV,
            smallLogoButtonRef: uploadSmallLogoButtonRefSV,
            faviconButtonRef: uploadFaviconButtonRefSV,
            emailLogoButtonRef: uploadEmailLogoButtonRefSV,
        },
        no: {
            bigLogoButtonRef: uploadBigLogoButtonRefNO,
            smallLogoButtonRef: uploadSmallLogoButtonRefNO,
            faviconButtonRef: uploadFaviconButtonRefNO,
            emailLogoButtonRef: uploadEmailLogoButtonRefNO,
        },
        fi: {
            bigLogoButtonRef: uploadBigLogoButtonRefFI,
            smallLogoButtonRef: uploadSmallLogoButtonRefFI,
            faviconButtonRef: uploadFaviconButtonRefFI,
            emailLogoButtonRef: uploadEmailLogoButtonRefFI,
        },
        da: {
            bigLogoButtonRef: uploadBigLogoButtonRefDA,
            smallLogoButtonRef: uploadSmallLogoButtonRefDA,
            faviconButtonRef: uploadFaviconButtonRefDA,
            emailLogoButtonRef: uploadEmailLogoButtonRefDA,
        },
        is: {
            bigLogoButtonRef: uploadBigLogoButtonRefIS,
            smallLogoButtonRef: uploadSmallLogoButtonRefIS,
            faviconButtonRef: uploadFaviconButtonRefIS,
            emailLogoButtonRef: uploadEmailLogoButtonRefIS,
        },
    };

    return (
        <>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`company_name_${flag}`}
                    placeholder="Enter company name"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeCompanyInfo(e, [countryCodesMap[flag]]);
                    }}
                    inputValue={data[countryCodesMap[flag]].company_name}
                    labelText="Company name"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`service_name_${flag}`}
                    placeholder="Enter service name"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeCompanyInfo(e, [countryCodesMap[flag]]);
                    }}
                    inputValue={data[countryCodesMap[flag]].service_name}
                    labelText="Service name"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`title_service_name_${flag}`}
                    placeholder="Enter title service name"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeCompanyInfo(e, flag);
                    }}
                    inputValue={data[flag]?.title_service_name}
                    labelText="Title service name"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id={`company_full_name_${flag}`}
                    placeholder="Enter full company name"
                    onInputChange={(e) => {
                        onChange(e, flag);
                        onChangeCompanyInfo(e, [countryCodesMap[flag]]);
                    }}
                    inputValue={data[countryCodesMap[flag]].company_full_name}
                    labelText="Full company name"
                    width="100%"
                />
            </div>
            <div className="form__item-wrapper">
                <p className="input-label">Logos</p>
                <LogosUploader
                    onFileSelect={(e, flag) => {
                        onFileSelect(e, flag);
                        refsMap[flag].bigLogoButtonRef.current.value = '';
                        refsMap[flag].smallLogoButtonRef.current.value = '';
                        refsMap[flag].faviconButtonRef.current.value = '';
                        refsMap[flag].emailLogoButtonRef.current.value = '';
                    }}
                    onLogosSizesChange={(e) => onLogosSizesChange(e, flag)}
                    bigLogo={logos[flag].bigLogo}
                    smallLogo={logos[flag].smallLogo}
                    favicon={logos[flag].favicon}
                    emailLogo={logos[flag].emailLogo}
                    bigLogoErrors={logoErrors[flag].bigLogoErrors}
                    smallLogoErrors={logoErrors[flag].smallLogoErrors}
                    faviconErrors={logoErrors[flag].faviconErrors}
                    emailLogoErrors={logoErrors[flag].emailLogoErrors}
                    onDeleteLogo={onDeleteLogo}
                    bigLogoButtonRef={refsMap[flag].bigLogoButtonRef}
                    smallLogoButtonRef={refsMap[flag].smallLogoButtonRef}
                    faviconButtonRef={refsMap[flag].faviconButtonRef}
                    emailLogoButtonRef={refsMap[flag].emailLogoButtonRef}
                    logosSizes={dataStore?.logos_sizes}
                    flag={flag}
                    isFaviconEnabled={true}
                />
            </div>
        </>
    );
}
